import axios from 'axios';
import {fetchConfig} from '../util/util';

const HOST_URL = fetchConfig('hostUrl')

const getAll = async () => {
  return (await axios.get(`${HOST_URL}/provider-category`)).data;
};

const post = async (data) => {
  return (await axios.post(`${HOST_URL}/provider-category`, data)).data;
};

const put = async (id, data) => {
  return (await axios.put(`${HOST_URL}/provider-category/${id}`, data)).data;
};

export default {getAll, post, put};
